<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { ref } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  job?: ReadonlyDeep<openapi.JobDetailedOpenapi>;
}
const props = withDefaults(defineProps<Props>(), {
  job: undefined,
});

const menu = ref(false);
</script>

<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    location="bottom"
    :class="$style.detailedJobShowTechnicalDataVMenu"
    data-testid="detailedJobShowTechnicalDataVMenu"
  >
    <template #activator="{ props: menuProps }">
      <KBtn
        :class="$style.btn"
        v-bind="menuProps"
        variant="text"
        size="sm"
        append-icon="mdi-chevron-down"
      >
        Show technical data
      </KBtn>
    </template>
    <v-card width="300" max-height="700">
      <div class="p-4">
        <small
          ><code>
            <pre class="m-0">{{ JSON.stringify(props.job, null, '  ') }}</pre>
          </code></small
        >
      </div>
    </v-card>
  </v-menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobShowTechnicalDataVMenu {
}
  .btn {
    text-transform: none;
  }

@media print {
  .detailedJobShowTechnicalDataVMenu {
    display: none;
  }
    .btn {
      display: none;
    }
}
</style>
